import React, {useMemo} from 'react'
import {componentName} from '../utils';
import {Col, Row} from 'react-bootstrap';

const EMPTY_FILTERS = {};

export const FiltersResume = ({
  commonFilters,
  filters: performanceFilters,
  followUpFilters = EMPTY_FILTERS,
  pagination,
  filtersPerRow = 3
}) => {
  const filters = useMemo(() => ({
    ...(commonFilters || performanceFilters || EMPTY_FILTERS),
    ...(followUpFilters || EMPTY_FILTERS)
  }), [commonFilters, followUpFilters, performanceFilters]);

  const elements = useMemo(() => {
    const keys = Object.keys(filters);
    if (keys.length > 0) {
      return keys.filter(key => checkEmpty(filters[key])).map(key => {
        if (key === 'rangeDate') {
          return {
            title: filters[key].paramName,
            content: `${filters[key].paramValue[0]} - ${filters[key].paramValue?.[1]}`
          }
        }

        if (filters[key].paramValue.length > 1) {
          return {
            title: filters[key].paramName,
            content: `${filters[key].displayValue.join(', ')}`
          }
        }

        return {
          title: filters[key].paramName,
          content: filters[key].displayValue[0]
        }
      });
    }

    return [];
  }, [filters])

  function checkEmpty(filter) {
    return filter?.displayValue?.length > 0 && filter?.paramValue?.length > 0
  }

  return (
    <div id={`${componentName}-filterResumeContainer`}>
      <Row>
      {
        elements.map(e => (
          <Col lg={12/filtersPerRow} key={e.title}>
            <p id={`${componentName}-${e.title}`}><b>{e.title}</b>: {e.content}</p>
          </Col>
        ))
      }
      </Row>
      <Row>
        <Col>
          <span id={`${componentName}-filterResumeCount`} className="text-primary">
            Your search returned {pagination.count} members
          </span>
        </Col>
      </Row>
    </div>
  )
}
